// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"0bcec463","296":"a8d5ac73","453":"69dc1995","455":"8541656f","977":"be067513"}[chunkId] + ".chunk.js";
};